// Tema dark/light do app. Default dark (identidade RTI). Persiste no localStorage.
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { loadPref, savePref } from '@/lib/pref-storage';

export type Theme = 'dark' | 'light';

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>(loadPref<Theme>('theme', 'dark'));

  // Aplica a classe correspondente na tag <html> (Tailwind darkMode:'class').
  function apply() {
    const html = document.documentElement;
    html.classList.toggle('dark', theme.value === 'dark');
    html.classList.toggle('light', theme.value === 'light');
  }

  function toggle() {
    theme.value = theme.value === 'dark' ? 'light' : 'dark';
  }

  // Ao mudar: persiste e reaplica a classe no html.
  watch(theme, () => { savePref('theme', theme.value); apply(); });

  return { theme, toggle, apply };
});
